import React, {
  PropTypes as T,
} from 'react';
import radium, { StyleRoot } from 'radium';
import { Link as link } from 'react-router';
import { connect } from 'react-redux';
import Helpers from '../../helpers';

const Link = radium(link);

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    margin: '24px auto 0 auto',
    flexWrap: 'wrap',
    width: '100%',
    maxWidth: 768,
    '@media (max-width: 767px)': {
      margin: '90px auto 0 auto',
    },
    '@media (max-width: 1023px)': {
      margin: '90px auto 0 auto',
    }
  },
  wrapper_TV: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '50% auto 0 auto',
    width: '50%',
  },
  alignCenter: {
    justifyContent: 'center',
  },
  link: {
    cursor: 'pointer',
    display: 'block',
    height: 72,
    width: 352,
    lineHeight: '72px',
    textAlign: 'center',
    color: '#004d9f',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: 3,
    textDecoration: 'none',
    margin: '18px 16px',
    fontSize: 24,
    letterSpacing: 10,
    fontWeight: 300,
    padding: '2px 0 0 10px',
    '@media (max-width: 767px)': {
      width: '100%',
      margin: '12px 16px',
      fontSize: 20,
      letterSpacing: 5,
    }
  },
  link_TV: {
    cursor: 'pointer',
    display: 'block',
    lineHeight: '72px',
    textAlign: 'center',
    color: '#004d9f',
    borderRadius: 3,
    textDecoration: 'none',
    margin: '18px 16px',
    letterSpacing: 10,
    fontWeight: 300,
    padding: '2px 0 0 10px',
    height: 80,
    width: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    fontSize: 32,
  },
  emphasis: {
    backgroundColor: '#fed312',
    '@media (max-width: 767px)': {
      marginBottom: 90,
    },
  },
};

function IndexNavigation(props) {
  var emphasis = styles.emphasis;
  var wrapper = styles.wrapper;
  var link = styles.link;

  if (Helpers.Session.isViaTV()) {
    emphasis = null;
    wrapper = styles.wrapper_TV;
    link = styles.link_TV;
  }

  var pageDetections = <Link to="/detections" style={[link, emphasis]}>自我聽篩</Link>;
  var pageComparisons = <Link to="/comparisons" style={link}>單雙耳比較圖</Link>;
  var pageSimulators = <Link to="/simulators" style={link}>聽力模擬</Link>;
  var pageQuestions = <Link to="/questions" style={link}>為何需要配戴助聽器</Link>;
  var pageEars = <Link to="/ears" style={link}>耳朵模擬圖</Link>;
  var pageSpecifications = <Link to="/specifications" style={link}>功能比較</Link>;
  var pageEarHair = <Link to="/earHair" style={link}>耳毛細胞比較圖</Link>;
  var pageSelections = <Link to="/selections" style={link}>助聽器選配室</Link>;

  if (Helpers.Session.isViaTV()) {
    pageDetections = <Link to="/detections/test/right/step1" style={[link, emphasis]}>自我聽篩</Link>;
    pageComparisons = null;
    pageSimulators = null;
    pageQuestions = null;
    pageEars = null;
    pageSpecifications = null;
    pageEarHair = null;
  }

  return (
    <StyleRoot style={wrapper}>
      {pageDetections}
      {pageComparisons}
      {pageSimulators}
      {pageQuestions}
      {pageEars}
      {pageSpecifications}
      {pageEarHair}
      {pageSelections}
    </StyleRoot>
  );
}

IndexNavigation.propTypes = {
  isLogined: T.bool,
};

export default connect(
  state => ({
    isLogined: state.Auth.isLogined,
  }),
)(radium(IndexNavigation));



// WEBPACK FOOTER //
// ./containers/Indexes/IndexNavigation.js